import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Pipeline flow icon.
 *
 * Three converging lines from the top flowing into a central node,
 * then a base bar at the bottom. Represents the pipeline orchestration
 * that funnels build/deploy jobs into a unified flow.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - Node dot: cyan accent at convergence point
 * - Base bar: purple accent fill at 6%
 */
export const PipelineIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Three converging lines from top into central node */}
    <path
      d="M5 4 L12 11 M12 4 L12 11 M19 4 L12 11"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Central node dot at convergence point */}
    <circle cx="12" cy="11" r={2} fill="#00d4ff" />
    <circle cx="12" cy="11" r={0.8} fill="white" />
    {/* Line from node down to base bar */}
    <path
      d="M12 13 L12 17"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Base bar with purple accent fill */}
    <rect
      x={4}
      y={17}
      width={16}
      height={3}
      rx={1}
      fill="#a855f7"
      fillOpacity={0.06}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

PipelineIcon.displayName = "PipelineIcon";

export default PipelineIcon;
